export default __webpack_public_path__ + "static/media/mail.25bc7dbc.svg";